import * as React from "react"
import { Button, Form, InputGroup, Dropdown, Row, Col, Spinner } from "react-bootstrap"
import { FaSearch } from "react-icons/fa"
import SearchField from "../api/SearchField"

interface SearchBarProps {
  searchFields: SearchField[]
  defaultField?: SearchField
  allowBlank?: boolean
  resetButton?: boolean
  placeholder?: string
  loading?: boolean
  variant?: string
  onSearch: (searchField: string, searchText: string) => void,
  formatValue?: (ID: string, value: string) => string
}

interface SearchBarState {
  selectedField?: SearchField
  searchText: string
}

export default class SearchBar extends React.PureComponent<SearchBarProps, SearchBarState> {
  state: SearchBarState = {
    selectedField: this.props.defaultField,
    searchText: ""
  }

  componentDidMount() {
    if (!this.props.allowBlank && this.props.searchFields.length) {
      this.setState({ selectedField: this.props.defaultField || this.props.searchFields[0] })
    }
  }

  componentDidUpdate(prevProps: SearchBarProps) {
    if (!this.props.allowBlank && prevProps.searchFields !== this.props.searchFields) {
      this.setState({ selectedField: this.props.defaultField || this.props.searchFields[0] })
    }
  }

  setSearchField = (field: SearchField) => {
    this.setState({ selectedField: field, searchText: "" })
  }

  handleSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value: string = e.target.value

    if (this.props.formatValue && this.state.selectedField) {
      value = this.props.formatValue(this.state.selectedField.ID, value)
    }

    this.setState({ searchText: value })
  }

  handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && this.state.searchText.length > 0) {
      this.onSearch()
    }
  }

  resetSearch = () => {
    const field = this.props.defaultField || this.props.allowBlank ? undefined : this.props.searchFields[0]
    this.setState({
      selectedField: field,
      searchText: ""
    })
    this.props.onSearch(field?.ID || "", "")
  }

  searchAllowed = () => this.state.searchText && this.props.searchFields.length

  onSearch = () => {
    if (this.searchAllowed()) {
      const searchField = this.state.selectedField ? this.state.selectedField.ID : ""
      this.props.onSearch(searchField, this.state.searchText)
    }
  }

  render = () => {
    return (
      <Row className="search-bar">
        <Col>
          <InputGroup size="sm">
            <InputGroup.Prepend>
              <Dropdown>
                <Dropdown.Toggle size="sm" variant="secondary">{this.state.selectedField ? this.state.selectedField.Name : this.props.placeholder || "Select"}</Dropdown.Toggle>
                <Dropdown.Menu className="secondary">
                  {this.props.searchFields.length > 0 ?
                    this.props.searchFields.map((item: SearchField, key: number) => <Dropdown.Item as={Button} onClick={() => this.setSearchField(item)} key={key} eventKey={item.ID} variant="menu-item">{item.Name}</Dropdown.Item>) :
                    <Dropdown.Item as={Button} variant="menu-item">No data found</Dropdown.Item>}
                </Dropdown.Menu>
              </Dropdown>
            </InputGroup.Prepend>
            <Form.Control type="text" placeholder="Search" value={this.state.searchText} onKeyDown={this.handleKeyDown} onChange={this.handleSearchTextChange} className="input-text" />
            <InputGroup.Append>
              <Button size="sm" variant="secondary" className="btn-rounded-right" disabled={!this.searchAllowed() || this.props.loading} onClick={this.onSearch}>
                {this.props.loading ? <Spinner animation="border" size="sm" /> : <FaSearch />}
              </Button>
            </InputGroup.Append>
          </InputGroup>
        </Col>
        {this.props.resetButton && <Col md={this.props.variant === "full-width" ? 1 : 2} className="px-0">
          <Button size="sm" variant="secondary" onClick={this.resetSearch}>CLEAR</Button>
        </Col>}
      </Row>
    )
  }

  static defaultProps = { resetButton: true }
}
